import ProviderAPI from "../../src/redux/ProviderAPI";

export const getRentalReport = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getRentReport",
    data: data,
  });

  return result;
};

export const getSaleReport = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getSaleReport",
    data: data,
  });

  return result;
};

export const getRevenueReport = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getRevenueReport",
    data: data,
  });

  return result;
};

export const getSaleRevenueReport = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getSaleRevenueReport",
    data: data,
  });

  return result;
};

export const getGuestReport = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getGuestRent",
    data: data,
  });

  return result;
};

export const getGuestReportSale = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getGuestSale",
    data: data,
  });

  return result;
};

export const getResultsAssetType = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/report/getResultsAssetType",
    data: data,
  });

  return result;
};
